import React from 'react';
import withDripCampaignLayout from '../../hoc/withDripCampaignLayout';
import UploadCsvContainer from '../../containers/UploadCsvContainer/UploadCsvContainer';

const UploadCsv = (props) => {
  return <UploadCsvContainer {...props}/>;
};

export default withDripCampaignLayout(UploadCsv);
